import { getWillieSupabaseClient } from '~/utils/supabase'

export const checkIsSuperAdmin = async (userID: string): Promise<boolean> => {
  const supabase = getWillieSupabaseClient()
  const { data } = await supabase
    .from('superusers')
    .select('user_id')
    .eq('user_id', userID)
    .maybeSingle()

  return data !== null
}
